export var PACKAGE_PREFIX = '@service-products';
export var fetchProductsWatcherSagaName = "".concat(PACKAGE_PREFIX, "/products-watcher-saga");
// because of ts
export var reducerProductsName = '@platform/service-products';
